import React from "react"
import {Button, Icon, Segment} from "semantic-ui-react"
import api from "../api"
import {Link, withRouter} from "react-router-dom"
import Step from "./components/Step/Step"
import ServiceProgress from "./components/ServiceProgress"
import getNextStep, {getPreviousStep} from "../util/getNextStep"
import {useTranslation} from 'react-i18next'

const TaskPage = withRouter(({match, history}) => {
    let {step_id} = match.params
    let step = api.getStep(step_id)

    let nextId = getNextId(step)
    let prevId = getPrevId(step)

    const {t} = useTranslation();

    if (!step) {
        console.error(`Could not load step:: ${step_id}`, api.order.steps)
    }
    return (
        <div className="pa2">
            <ServiceProgress/>
            <Segment className="page-padding">
                <Step step={step}/>
            </Segment>
            {/*WIZARD NAVIGATION*/}
            <div className="pt3">
                <Link className="fl" to="/tasks"><Button basic inverted icon="close"/></Link>
                <div className="fr pb2 task-nav-buttons">
                    <ButtonContinue step={step} to={prevId} history={history}><Icon
                        name='chevron left'/></ButtonContinue>
                    <ButtonContinue step={step} to={nextId} history={history}>{t("general.step.next")}<Icon name='chevron right'/></ButtonContinue>
                    {(!nextId) ?
                        <Link onClick={() => {
                            api.signals.stepChange.dispatch()
                        }
                    } to="/documents"><Button color="green">{t("general.attachments")}</Button></Link> : null}
                </div>
            </div>
        </div>
    )
})

const ButtonContinue = ({children, to, inverted = true, color, history}) => {
    if (to) {
    return (
        <Button color={color} onClick={() => {
            api.signals.stepChange.dispatch()
            history.push(`/tasks/${to}`)
        }} inverted={inverted}>
        {children}</Button>
        )
    }
        return null
    }

const getNextId = (step) => {
    let s = getNextStep(step)
    if (s) return s.Id
    return false
}

const getPrevId = (step) => {
    let s = getPreviousStep(step)
    if (s) return s.Id
    return false
}

export default TaskPage



// WEBPACK FOOTER //
// ./src/pages/TaskPage.js